export const SET_CARDS_JSON = 'SET_CARDS_JSON';
export const SET_INSIGHTS_JSON = 'SET_INSIGHTS_JSON';
export const SET_TAG_FILTER = 'SET_TAG_FILTER';
export const SET_TOPIC_FILTER = 'SET_TOPIC_FILTER';
export const CHANGE_TAG_FILTER = 'CHANGE_TAG_FILTER';

export const DEFAULT_CARD_TAGS = {
  "General": "#87b048",
  "Article": "#22a590",
  "News": "#337681",
  "Comment": "#6bc3dc",
  "Client Alert": "#6bc3dc",
  "Event": "#845ea6",
  "Case study": "#853576",
  "Resource": "#ca392f",
  "Audio": "#67717d",
  "Video": "#54555d"
};

// General
// 87b048

// Article
// 22a590

// News
// 337681

// Alert
// 6bc3dc

// Event
// 845ea6

// Case Study
// 853576

// Resource
// ca392f

// Video
// 67717d

// Podcast
// 54555d

// Audio
// ab9860



// WEBPACK FOOTER //
// ./src/enums/enums.js